import { render, staticRenderFns } from "./AssetTypeList.vue?vue&type=template&id=f8713b6a&scoped=true&"
import script from "./AssetTypeList.vue?vue&type=script&lang=js&"
export * from "./AssetTypeList.vue?vue&type=script&lang=js&"
import style0 from "./AssetTypeList.vue?vue&type=style&index=0&id=f8713b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8713b6a",
  null
  
)

export default component.exports